import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
export function Home() {
  return <>
      <Hero data-id="element-429" />
      <Stats data-id="element-430" />
    </>;
}